<template>
  <div class="form-group  row">
    <label style="font-weight: bold">{{name}}</label>
    <div class="form-control m-input " style="width: auto;height: auto!important;">
      <colorSelect v-model="colorSelect" :defaultColor="value.toString()"  v-on:change="updateContent($event)" style="width: 100%"></colorSelect>
    </div>
  </div>
</template>

<script>
import colorSelect from './vue-color/color-picker/src/color-picker'
export default {
  name: "ControlLibraryColor",
  props: [
    "name", "value" ,"field"
  ],
  components: {
    colorSelect
  },
  data() {
    return {
      colorSelect : ""
    }
  },
  methods: {
    updateContent(content) {
      this.$emit('update', {field: this.field, value: content})
    }
  }
}
</script>

<style scoped>

</style>
